import * as React from 'react';
import { ElementFactory, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';
import { TYPE as MuiTextFieldType, MuiTextFieldModel, MuiTextField } from './MuiTextField';
import { TYPE as MuiRadioGroupType, MuiRadioGroupModel, MuiRadioGroup } from './MuiRadioGroup';
import { TYPE as MuiSelectType, MuiSelectModel, MuiSelect } from './MuiSelect';
import { TYPE as MuiSubscriptionsType, MuiSubscriptionsModel, MuiSubscriptions } from './MuiSubscriptions';
import {
  TYPE as MuiAdditionalProductsType,
  MuiAdditionalProductsModel,
  MuiAdditionalProducts
} from './MuiAdditionalProducts';
import { TYPE as MuiPhoneInputType, MuiPhoneInputModel, MuiPhoneInput } from './MuiPhoneInput';
import { TYPE as MuiDiscountType, MuiDiscountModel, MuiDiscount } from './MuiDiscount';
import { TYPE as MuiCountriesType, MuiCountriesModel, MuiCountries } from './MuiCountries';
import { TYPE as MuiAddressType, MuiAddressModel, MuiAddress } from './MuiAddress';
import { TYPE as MuiCheckboxType, MuiCheckboxModel, MuiCheckbox } from './MuiCheckbox';
import { TYPE as MuiCompanySearchType, MuiCompanySearchModel, MuiCompanySearch } from './MuiCompanySearch';
import { TYPE as MuiListType, MuiListModel, MuiList } from './MuiList';
import { TYPE as MuiMembershipType, MuiMembershipModel, MuiMembership } from './MuiMembership';
import { TYPE as MuiPrivacyConsentType, MuiPrivacyConsentModel, MuiPrivacyConsent } from './MuiPrivacyConsent';

export const registerCustomComponents = () => {
  ElementFactory.Instance.registerElement(MuiTextFieldType, name => new MuiTextFieldModel(name));
  ElementFactory.Instance.registerElement(MuiRadioGroupType, name => new MuiRadioGroupModel(name));
  ElementFactory.Instance.registerElement(MuiSelectType, name => new MuiSelectModel(name));
  ElementFactory.Instance.registerElement(MuiSubscriptionsType, name => new MuiSubscriptionsModel(name));
  ElementFactory.Instance.registerElement(MuiAdditionalProductsType, name => new MuiAdditionalProductsModel(name));
  ElementFactory.Instance.registerElement(MuiPhoneInputType, name => new MuiPhoneInputModel(name));
  ElementFactory.Instance.registerElement(MuiDiscountType, name => new MuiDiscountModel(name));
  ElementFactory.Instance.registerElement(MuiCountriesType, name => new MuiCountriesModel(name));
  ElementFactory.Instance.registerElement(MuiAddressType, name => new MuiAddressModel(name));
  ElementFactory.Instance.registerElement(MuiCheckboxType, name => new MuiCheckboxModel(name));
  ElementFactory.Instance.registerElement(MuiCompanySearchType, name => new MuiCompanySearchModel(name));
  ElementFactory.Instance.registerElement(MuiListType, name => new MuiListModel(name));
  ElementFactory.Instance.registerElement(MuiMembershipType, name => new MuiMembershipModel(name));
  ElementFactory.Instance.registerElement(MuiPrivacyConsentType, name => new MuiPrivacyConsentModel(name));

  Serializer.addClass(
    MuiTextFieldType,
    [
      { name: 'limitInput', category: 'general' },
      { name: 'inputType', category: 'general' },
      { name: 'tooltip', category: 'general' },
      { name: 'fieldWidth', category: 'general' },
      { name: 'titleForMobile', category: 'general' }
    ],
    () => new MuiTextFieldModel(''),
    'question'
  );
  Serializer.addClass(MuiRadioGroupType, [], () => new MuiRadioGroupModel(''), 'radiogroup');

  Serializer.addClass(
    MuiSelectType,
    [{ name: 'choices', category: 'choices' }],
    () => new MuiSelectModel(''),
    'question'
  );
  Serializer.addClass(
    MuiSubscriptionsType,
    [
      { name: 'orderByOriginalItem', category: 'choices' },
      { name: 'filterChoicesOnRender', category: 'choices' },
      { name: 'price', category: 'general' },
      { name: 'productDetails', category: 'general' },
      { name: 'productIcons', category: 'general' },
      { name: 'strings', category: 'general' }
    ],
    () => new MuiSubscriptionsModel(''),
    'radiogroup'
  );
  Serializer.addClass(
    MuiAdditionalProductsType,
    [{ name: 'selfServeText', category: 'choices' }],
    () => new MuiAdditionalProductsModel(''),
    MuiSubscriptionsType
  );
  Serializer.addClass(MuiPhoneInputType, [], () => new MuiPhoneInputModel(''), 'question');
  Serializer.addClass(
    MuiDiscountType,
    [
      { name: 'validatorUrl', category: 'general' },
      { name: 'strings', category: 'general' }
    ],
    () => new MuiDiscountModel(''),
    'question'
  );
  Serializer.addClass(
    MuiCountriesType,
    [{ name: 'strings', category: 'general' }],
    () => new MuiCountriesModel(''),
    'question'
  );
  Serializer.addClass(MuiAddressType, [], () => new MuiAddressModel(''), 'question');
  Serializer.addClass(
    MuiCheckboxType,
    [{ name: 'links', category: 'general' }],
    () => new MuiCheckboxModel(''),
    'boolean'
  );
  Serializer.addClass(
    MuiCompanySearchType,
    [
      { name: 'providers', category: 'general' },
      { name: 'customDisabled', category: 'general' }
    ],
    () => new MuiCompanySearchModel(''),
    'question'
  );
  Serializer.addClass(
    MuiListType,
    [{ name: 'listAlert', category: 'general' }],
    () => new MuiListModel(''),
    'radiogroup'
  );
  Serializer.addClass(
    MuiMembershipType,
    [
      { name: 'membershipDetails', category: 'general' },
      { name: 'strings', category: 'general' }
    ],
    () => new MuiMembershipModel(''),
    'radiogroup'
  );
  Serializer.addClass(MuiPrivacyConsentType, [], () => new MuiPrivacyConsentModel(''), MuiCheckboxType);

  ReactQuestionFactory.Instance.registerQuestion(MuiTextFieldType, props => {
    return React.createElement(MuiTextField, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiRadioGroupType, props => {
    return React.createElement(MuiRadioGroup, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiSelectType, props => {
    return React.createElement(MuiSelect, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiSubscriptionsType, props => {
    return React.createElement(MuiSubscriptions, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiAdditionalProductsType, props => {
    return React.createElement(MuiAdditionalProducts, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiPhoneInputType, props => {
    return React.createElement(MuiPhoneInput, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiDiscountType, props => {
    return React.createElement(MuiDiscount, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiCountriesType, props => {
    return React.createElement(MuiCountries, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiAddressType, props => {
    return React.createElement(MuiAddress, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiCheckboxType, props => {
    return React.createElement(MuiCheckbox, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiCompanySearchType, props => {
    return React.createElement(MuiCompanySearch, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiListType, props => {
    return React.createElement(MuiList, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiMembershipType, props => {
    return React.createElement(MuiMembership, props);
  });
  ReactQuestionFactory.Instance.registerQuestion(MuiPrivacyConsentType, props => {
    return React.createElement(MuiPrivacyConsent, props);
  });
};
